<h3 class="headline">Your account is limited</h3>
@if (memberService.account.verification_submitted) {
  <div class="ash-color">
    <p>
      We are currently reviewing your verification submission. Your account will be limited until the verification is
      approved.
    </p>
    <p class="mf-0">Please check your email or back here shortly.</p>
  </div>
} @else {
  <div class="display-flex flex-direction-column">
    <p class="ash-color">We have reviewed your account and require you to verify your profile.</p>
    <a
      class="mb-4"
      sbButton
      [routerLink]="['/next/me/verifications']"
      [size]="'big'"
      [stretchable]="true"
      [variant]="'fill-verified'"
      (click)="confirm()"
      >Get Verified</a
    >
    <button sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="openWhyVerify()">
      Why?
    </button>
  </div>
}
